import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ThemedImageNamesEnum} from '../../../../../helpers/imageThemeHelpers';
import {ThemedImage} from '../../../../common/images/themedImage';

/*
 * Style.
 */

const StyledEmptyStateWrapper = styled.div`
  width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledTextDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;

  margin-top: 32px;

  color: ${(p) => p.theme.greys.shade80};
`;

const StyledTitleDiv = styled.div`
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.veryLarge};

  margin-bottom: 10px;
  text-align: center;
`;

const StyledDescriptionDiv = styled.div`
  font-weight: ${fontWeights.normal};
  font-size: ${fontSizes.medium};

  text-align: center;

  color: ${(p) => p.theme.greys.shade70};
  line-height: 21px;
`;

const StyledButtonsDiv = styled.div`
  display: flex;
  gap: 16px;
  padding-top: 16px;
  align-items: center;
`;

/*
 * Props.
 */

interface CtaEmptyStateProps {
  image: ThemedImageNamesEnum;
  title: ReactNode;
  description: ReactNode;
  children: ReactNode;
}

/*
 * Component.
 */

export const CtaEmptyState: FC<CtaEmptyStateProps> = (props) => {
  const {image, title, description, children} = props;
  return (
    <StyledEmptyStateWrapper>
      <ThemedImage image={image} />
      <StyledTextDiv>
        <StyledTitleDiv>{title}</StyledTitleDiv>
        <StyledDescriptionDiv>{description}</StyledDescriptionDiv>
      </StyledTextDiv>
      <StyledButtonsDiv>{children}</StyledButtonsDiv>
    </StyledEmptyStateWrapper>
  );
};
